import { Button } from '@mui/material';
import { ChevronUpIcon } from 'src/icons/ChevronUpIcon';
import { RefObject } from "react";

type Props = {
    scrollRef: RefObject<HTMLDivElement | null>;
};

export function JumpToUpButton({ scrollRef }: Props) {
    const handleClick = () => {
        scrollRef.current?.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <Button
            onClick={handleClick}
            aria-label="Scroll to top"
            sx={{
                position: 'fixed',
                bottom: '-25px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: 'rgba(0, 145, 255, 0.18)',
                boxShadow: '0 0 7px 0px #0091ff2b',
                width: '50px',
                height: '50px',
                borderRadius: '35px',
                minWidth: 'unset',
                padding: 0,
                zIndex: 999,
                overflow: 'hidden',
                pointerEvents: 'auto',
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '50%',
                    background: 'white',
                },
                '&:hover': {
                    background: 'rgba(0, 0, 0, 0.9)',
                },
            }}
        >
            <ChevronUpIcon
                sx={{
                    color: '#fff',
                    fontSize: '35px',
                    position: 'relative',
                    bottom: '10px',
                }}
            />
        </Button>
    );
}
